import { render } from "./ModalSidebarComponent.vue?vue&type=template&id=3057956b&scoped=true&ts=true"
import script from "./ModalSidebarComponent.vue?vue&type=script&lang=ts"
export * from "./ModalSidebarComponent.vue?vue&type=script&lang=ts"

import "./ModalSidebarComponent.vue?vue&type=style&index=0&id=3057956b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3057956b"]])

export default __exports__